import { Component } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { UtilisService } from '../utilis.service';

@Component({
  selector: 'app-cryptojs-test',
  templateUrl: './cryptojs-test.component.html',
  styleUrls: ['./cryptojs-test.component.scss']
})
export class CryptojsTestComponent {

  plainText: string;
  encryptText: string;
  encPassword: string;
  decPassword: string;
  conversionEncryptOutput: string;
  conversionDecryptOutput: string;

  constructor(private utilService: UtilisService) { }

  convertText(conversion: string) {
    if (conversion == "encrypt") {
      this.conversionEncryptOutput = CryptoJS.AES.encrypt(this.plainText.trim(), this.encPassword.trim()).toString();
    }
    else {
      this.conversionDecryptOutput = CryptoJS.AES.decrypt(this.encryptText.trim(), this.decPassword.trim()).toString(CryptoJS.enc.Utf8);

    }
  }

  ngOnInit(): void {
  }

}
